import React, { useEffect } from "react";
import ContactUs from "../components/contact-us/contactUs.jsx";

export default function Contact() {
  useEffect(() => {
    document.title = "Contact Us | FameWheels";
  }, []);
  return (
    <>
      <ContactUs />
    </>
  );
}
